import { getCoreDataSecurityMonitorsSlice } from './get';
import { postCoreDataSecurityMonitorsSlice } from './post';

export const { requestGetCoreDataSecurityMonitors, resetGetCoreDataSecurityMonitors } =
	getCoreDataSecurityMonitorsSlice.asyncActionCreators;

export const { requestPostCoreDataSecurityMonitors, resetPostCoreDataSecurityMonitors } =
	postCoreDataSecurityMonitorsSlice.asyncActionCreators;

export * from './_id/actions';
export * from './application/actions';
export * from './all/actions';
